/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddRangeDataRequest } from '../models/AddRangeDataRequest';
import type { BulkCreateDataModelRangeNameRequest } from '../models/BulkCreateDataModelRangeNameRequest';
import type { CreateDataModelRequest } from '../models/CreateDataModelRequest';
import type { CreateDataModelV2Request } from '../models/CreateDataModelV2Request';
import type { DataModel } from '../models/DataModel';
import type { DataModelComposite } from '../models/DataModelComposite';
import type { DataModelCompositeSort } from '../models/DataModelCompositeSort';
import type { DataModelCompositeStats } from '../models/DataModelCompositeStats';
import type { DataModelEligibilityStats } from '../models/DataModelEligibilityStats';
import type { DataModelMassActionPropose } from '../models/DataModelMassActionPropose';
import type { DataModelMassActionValueToChange } from '../models/DataModelMassActionValueToChange';
import type { DataModelRangeAnalysisPopulationRequest } from '../models/DataModelRangeAnalysisPopulationRequest';
import type { DataModelRangeAnalysisRange } from '../models/DataModelRangeAnalysisRange';
import type { DataModelRangeAnalysisRangePoints } from '../models/DataModelRangeAnalysisRangePoints';
import type { DataModelRangeAnalysisStats } from '../models/DataModelRangeAnalysisStats';
import type { DataModelRangeGroup } from '../models/DataModelRangeGroup';
import type { DataModelRangeGuidelineItem } from '../models/DataModelRangeGuidelineItem';
import type { DataModelRangeName } from '../models/DataModelRangeName';
import type { DataModelRangeSet } from '../models/DataModelRangeSet';
import type { DataModelRangeSetAggregation } from '../models/DataModelRangeSetAggregation';
import type { DataModelRangeSetSort } from '../models/DataModelRangeSetSort';
import type { DataModelRangeSetStatus } from '../models/DataModelRangeSetStatus';
import type { DataModelRangeZone } from '../models/DataModelRangeZone';
import type { DataModelSalaryRange } from '../models/DataModelSalaryRange';
import type { DataModelSalaryRangeCompletionStatus } from '../models/DataModelSalaryRangeCompletionStatus';
import type { DataModelSalaryRangeExportTableConfig } from '../models/DataModelSalaryRangeExportTableConfig';
import type { DataModelSalaryRangeMassCompositeUpdateAction } from '../models/DataModelSalaryRangeMassCompositeUpdateAction';
import type { DataModelSalaryRangeSort } from '../models/DataModelSalaryRangeSort';
import type { DataModelSalaryRangeZoneGroupCombination } from '../models/DataModelSalaryRangeZoneGroupCombination';
import type { PopulateDataModelRequest } from '../models/PopulateDataModelRequest';
import type { PopulateFromScratchRequest } from '../models/PopulateFromScratchRequest';
import type { RangeAssignmentOption } from '../models/RangeAssignmentOption';
import type { RangeGroupSort } from '../models/RangeGroupSort';
import type { RangeZoneSort } from '../models/RangeZoneSort';
import type { SalaryRangeTypeOfPay } from '../models/SalaryRangeTypeOfPay';
import type { SetRangeValuesRequest } from '../models/SetRangeValuesRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class DataModelService {

    /**
     * return list of data models
     * @returns DataModel Success
     * @throws ApiError
     */
    public static getDataModelList({
        plan,
        limit,
        offset,
    }: {
        /**
         * Plan Id
         */
        plan?: number,
        /**
         * Pagination Limit
         */
        limit?: number,
        /**
         * Pagination Offset
         */
        offset?: number,
    }): CancelablePromise<Array<DataModel>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dataModel',
            query: {
                'plan': plan,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * create new data model
     * @returns DataModel Success
     * @throws ApiError
     */
    public static createDataModel({
        requestBody,
    }: {
        requestBody: CreateDataModelRequest,
    }): CancelablePromise<DataModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dataModel',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * create new empty data model
     * @returns DataModel Success
     * @throws ApiError
     */
    public static createDataModelV2({
        requestBody,
    }: {
        requestBody: CreateDataModelV2Request,
    }): CancelablePromise<DataModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dataModel/v2',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }

    /**
     * return data model
     * @returns DataModel Success
     * @throws ApiError
     */
    public static getDataModel({
        id,
    }: {
        /**
         * Data Model Id
         */
        id: number,
    }): CancelablePromise<DataModel> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dataModel/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * update data model
     * @returns DataModel Success
     * @throws ApiError
     */
    public static updateDataModel({
        id,
        requestBody,
    }: {
        /**
         * Data Model Id
         */
        id: number,
        requestBody?: {
            name?: string;
            description?: string | null;
            typeOfPay?: SalaryRangeTypeOfPay;
            options?: Record<string, any>;
            isAutoApplySpread?: boolean;
        },
    }): CancelablePromise<DataModel> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/dataModel/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete data model
     * @returns any Success
     * @throws ApiError
     */
    public static deleteDataModel({
        id,
    }: {
        /**
         * Data Model ID
         */
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/dataModel/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * recalculate data model stats
     * @returns any Success
     * @throws ApiError
     */
    public static recalculateDataModel({
        id,
    }: {
        /**
         * Data Model Id
         */
        id: number,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dataModel/{id}/recalculate',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * export data model
     * @returns any Success
     * @throws ApiError
     */
    public static exportDataModel({
        id,
        requestBody,
    }: {
        /**
         * Data Model Id
         */
        id: number,
        requestBody: {
            /**
             * Filter by range zone
             */
            rangeZoneId?: Array<number>;
            /**
             * Filter by range group
             */
            rangeGroupId?: Array<number>;
            /**
             * Filter by range name
             */
            rangeName?: Array<number>;
            /**
             * Table config
             */
            config?: Array<DataModelSalaryRangeExportTableConfig>;
        },
    }): CancelablePromise<{
        message?: string;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dataModel/{id}/export',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * return data model salary ranges
     * @returns DataModelSalaryRange Success
     * @throws ApiError
     */
    public static getDataModelSalaryRanges({
        id,
        rangeZones,
        rangeGroups,
        rangeNames,
        search,
        limit,
        offset,
        completionStatus,
        sort,
    }: {
        /**
         * Data Model Id
         */
        id: number,
        rangeZones?: Array<number>,
        rangeGroups?: Array<number>,
        rangeNames?: Array<number>,
        search?: string,
        /**
         * Pagination Limit
         */
        limit?: number,
        /**
         * Pagination Offset
         */
        offset?: number,
        completionStatus?: DataModelSalaryRangeCompletionStatus,
        /**
         * Sorting
         */
        sort?: DataModelSalaryRangeSort,
    }): CancelablePromise<Array<DataModelSalaryRange>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dataModel/{id}/salaryRange',
            path: {
                'id': id,
            },
            query: {
                'rangeZones': rangeZones,
                'rangeGroups': rangeGroups,
                'rangeNames': rangeNames,
                'search': search,
                'limit': limit,
                'offset': offset,
                'completionStatus': completionStatus,
                'sort': sort,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * return the salary ranges of one range set (zone + group) for range analysis
     * @returns DataModelRangeAnalysisRange Success
     * @throws ApiError
     */
    public static getDataModelRangeAnalysisRanges({
        id,
        zoneId,
        groupId,
        jobFamily,
        jobSubFamily,
        limit,
        offset,
    }: {
        /**
         * Data Model Id
         */
        id: number,
        /**
         * Range Zone id of the range set
         */
        zoneId: number,
        /**
         * Range Group id of the range set
         */
        groupId: number,
        /**
         * Only ranges containing jobs of these families
         */
        jobFamily?: Array<number>,
        /**
         * Only ranges containing jobs of these sub families
         */
        jobSubFamily?: Array<number>,
        /**
         * Pagination Limit
         */
        limit?: number,
        /**
         * Pagination Offset
         */
        offset?: number,
    }): CancelablePromise<Array<DataModelRangeAnalysisRange>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dataModel/{id}/rangeAnalysis/ranges',
            path: {
                'id': id,
            },
            query: {
                'zoneId': zoneId,
                'groupId': groupId,
                'jobFamily': jobFamily,
                'jobSubFamily': jobSubFamily,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * return live employee table statistics for the given salary ranges
     * @returns DataModelRangeAnalysisStats Success
     * @throws ApiError
     */
    public static getDataModelRangeAnalysisStats({
        id,
        requestBody,
    }: {
        /**
         * Data Model Id
         */
        id: number,
        requestBody: DataModelRangeAnalysisPopulationRequest,
    }): CancelablePromise<Array<DataModelRangeAnalysisStats>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dataModel/{id}/rangeAnalysis/stats',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * return chart points (individual employee values) for the given salary ranges
     * @returns DataModelRangeAnalysisRangePoints Success
     * @throws ApiError
     */
    public static getDataModelRangeAnalysisPoints({
        id,
        requestBody,
    }: {
        /**
         * Data Model Id
         */
        id: number,
        requestBody: DataModelRangeAnalysisPopulationRequest,
    }): CancelablePromise<Array<DataModelRangeAnalysisRangePoints>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dataModel/{id}/rangeAnalysis/points',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * return data model range zones
     * @returns DataModelRangeZone Success
     * @throws ApiError
     */
    public static getDataModelRangeZones({
        id,
        sort,
        limit,
        offset,
        ignorePagination,
        ids,
        search,
        hasSalaryRanges,
    }: {
        /**
         * Data Model Id
         */
        id: number,
        /**
         * Sorting
         */
        sort?: RangeZoneSort,
        /**
         * Number of items to return
         */
        limit?: number,
        /**
         * Number of items to skip
         */
        offset?: number,
        /**
         * If true, return all items without pagination
         */
        ignorePagination?: boolean,
        /**
         * Filter by specific zone IDs
         */
        ids?: Array<number>,
        /**
         * Search range zones by level1, level2 or level3
         */
        search?: string,
        /**
         * If true, return only zones that have at least one salary range in the data model
         */
        hasSalaryRanges?: boolean,
    }): CancelablePromise<Array<DataModelRangeZone>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dataModel/{id}/rangeZone',
            path: {
                'id': id,
            },
            query: {
                'sort': sort,
                'limit': limit,
                'offset': offset,
                'ignorePagination': ignorePagination,
                'ids': ids,
                'search': search,
                'hasSalaryRanges': hasSalaryRanges,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Create a new data model range zone
     * @returns DataModelRangeZone Created
     * @throws ApiError
     */
    public static createDataModelRangeZone({
        id,
        requestBody,
    }: {
        /**
         * Data Model Id
         */
        id: number,
        requestBody: {
            level1: string;
            level2?: string;
            level3?: string;
            eligibility?: {
                paymarketId?: Array<number>;
            } | null;
        },
    }): CancelablePromise<DataModelRangeZone> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dataModel/{id}/rangeZone',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update data model range zone
     * @returns any Success
     * @throws ApiError
     */
    public static updateDataModelRangeZone({
        id,
        zoneId,
        requestBody,
    }: {
        id: number,
        zoneId: number,
        requestBody: {
            level1: string;
            level2?: string;
            level3?: string;
            eligibility?: Record<string, any> | null;
        },
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/dataModel/{id}/rangeZone/{zoneId}',
            path: {
                'id': id,
                'zoneId': zoneId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete data model range zone
     * @returns any Success
     * @throws ApiError
     */
    public static deleteDataModelRangeZone({
        id,
        zoneId,
    }: {
        id: number,
        zoneId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/dataModel/{id}/rangeZone/{zoneId}',
            path: {
                'id': id,
                'zoneId': zoneId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * return data model range groups
     * @returns DataModelRangeGroup Success
     * @throws ApiError
     */
    public static getDataModelRangeGroups({
        id,
        sort,
        limit,
        offset,
        ignorePagination,
        ids,
        search,
        hasSalaryRanges,
    }: {
        /**
         * Data Model Id
         */
        id: number,
        /**
         * Sorting
         */
        sort?: RangeGroupSort,
        /**
         * Number of items to return
         */
        limit?: number,
        /**
         * Number of items to skip
         */
        offset?: number,
        /**
         * If true, return all items without pagination
         */
        ignorePagination?: boolean,
        /**
         * Filter by specific group IDs
         */
        ids?: Array<number>,
        /**
         * Search range groups by level1, level2 or level3
         */
        search?: string,
        /**
         * If true, return only groups that have at least one salary range in the data model
         */
        hasSalaryRanges?: boolean,
    }): CancelablePromise<Array<DataModelRangeGroup>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dataModel/{id}/rangeGroup',
            path: {
                'id': id,
            },
            query: {
                'sort': sort,
                'limit': limit,
                'offset': offset,
                'ignorePagination': ignorePagination,
                'ids': ids,
                'search': search,
                'hasSalaryRanges': hasSalaryRanges,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Create a new data model range group
     * @returns DataModelRangeGroup Created
     * @throws ApiError
     */
    public static createDataModelRangeGroup({
        id,
        requestBody,
    }: {
        /**
         * Data Model Id
         */
        id: number,
        requestBody: {
            level1: string;
            level2?: string;
            level3?: string;
            eligibility?: {
                structure?: Array<string>;
                familyId?: Array<number>;
                subFamilyId?: Array<number>;
                categoryId?: Array<number>;
                flsa?: Array<string>;
            } | null;
        },
    }): CancelablePromise<DataModelRangeGroup> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dataModel/{id}/rangeGroup',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get data model salary range group by id
     * @returns DataModelRangeGroup Success
     * @throws ApiError
     */
    public static getDataModelRangeGroup({
        id,
        groupId,
    }: {
        id: number,
        groupId: number,
    }): CancelablePromise<DataModelRangeGroup> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dataModel/{id}/rangeGroup/{groupId}',
            path: {
                'id': id,
                'groupId': groupId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update data model salary range group
     * @returns any Success
     * @throws ApiError
     */
    public static updateDataModelRangeGroup({
        id,
        groupId,
        requestBody,
    }: {
        id: number,
        groupId: number,
        requestBody: {
            level1: string;
            level2?: string;
            level3?: string;
            eligibility?: Record<string, any> | null;
        },
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/dataModel/{id}/rangeGroup/{groupId}',
            path: {
                'id': id,
                'groupId': groupId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete data model salary range group
     * @returns any Success
     * @throws ApiError
     */
    public static deleteDataModelRangeGroup({
        id,
        groupId,
    }: {
        id: number,
        groupId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/dataModel/{id}/rangeGroup/{groupId}',
            path: {
                'id': id,
                'groupId': groupId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * export range zones of data model
     * @returns any Success
     * @throws ApiError
     */
    public static exportDataModelRangeZones({
        id,
    }: {
        id: number,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dataModel/{id}/rangeZone/export',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * export range groups of data model
     * @returns any Success
     * @throws ApiError
     */
    public static exportDataModelRangeGroups({
        id,
    }: {
        id: number,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dataModel/{id}/rangeGroup/export',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * return data model range name
     * @returns DataModelRangeName Success
     * @throws ApiError
     */
    public static getDataModelRangeNames({
        id,
        limit,
        offset,
        ids,
        search,
        ignorePagination,
        hasSalaryRanges,
    }: {
        /**
         * Data Model Id
         */
        id: number,
        /**
         * Number of items to return
         */
        limit?: number,
        /**
         * Number of items to skip
         */
        offset?: number,
        /**
         * Filter by specific range name IDs
         */
        ids?: Array<number>,
        /**
         * Search range names by name
         */
        search?: string,
        /**
         * If true, return all items without pagination
         */
        ignorePagination?: boolean,
        /**
         * If true, return only range names that have at least one salary range in the data model
         */
        hasSalaryRanges?: boolean,
    }): CancelablePromise<Array<DataModelRangeName>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dataModel/{id}/rangeName',
            path: {
                'id': id,
            },
            query: {
                'limit': limit,
                'offset': offset,
                'ids': ids,
                'search': search,
                'ignorePagination': ignorePagination,
                'hasSalaryRanges': hasSalaryRanges,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Create data model range name
     * @returns DataModelRangeName Success
     * @throws ApiError
     */
    public static createDataModelRangeName({
        id,
        requestBody,
    }: {
        /**
         * Data Model Id
         */
        id: number,
        requestBody: {
            name: string;
            eligibility?: Record<string, any> | null;
        },
    }): CancelablePromise<DataModelRangeName> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dataModel/{id}/rangeName',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update data model salary range name
     * @returns any Success
     * @throws ApiError
     */
    public static updateDataModelRangeName({
        id,
        nameId,
        requestBody,
    }: {
        id: number,
        nameId: number,
        requestBody: {
            name: string;
            eligibility?: Record<string, any> | null;
        },
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/dataModel/{id}/rangeName/{nameId}',
            path: {
                'id': id,
                'nameId': nameId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete data model range name
     * @returns any Success
     * @throws ApiError
     */
    public static deleteDataModelRangeName({
        id,
        nameId,
    }: {
        id: number,
        nameId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/dataModel/{id}/rangeName/{nameId}',
            path: {
                'id': id,
                'nameId': nameId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * bulk create data model range names
     * @returns any Success
     * @throws ApiError
     */
    public static bulkCreateDataModelRangeNames({
        id,
        requestBody,
    }: {
        /**
         * Data Model Id
         */
        id: number,
        requestBody: BulkCreateDataModelRangeNameRequest,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dataModel/{id}/rangeName/bulk',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * export range names of data model
     * @returns any Success
     * @throws ApiError
     */
    public static exportDataModelRangeNames({
        id,
    }: {
        id: number,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dataModel/{id}/rangeName/export',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * return range name IDs already assigned to a zone+group combination
     * @returns DataModelRangeName Success
     * @throws ApiError
     */
    public static getAssignedRangeNames({
        id,
        rangeZoneId,
        rangeGroupId,
    }: {
        /**
         * Data Model Id
         */
        id: number,
        /**
         * Range Zone Id
         */
        rangeZoneId: number,
        /**
         * Range Group Id
         */
        rangeGroupId: number,
    }): CancelablePromise<Array<DataModelRangeName>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dataModel/{id}/rangeName/assigned',
            path: {
                'id': id,
            },
            query: {
                'rangeZoneId': rangeZoneId,
                'rangeGroupId': rangeGroupId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Return DataModelRangeName options keyed by (groupId, zoneId)
     * For each (groupId, zoneId) pair in the request body, returns the list of
     * DataModelRangeName entries that have at least one DataModelSalaryRange for
     * that combination in the given data model. The response is a map keyed by
     * "${groupId}-${zoneId}". Pairs that have no matching ranges are returned
     * with an empty array.
     *
     * @returns DataModelRangeName Success
     * @throws ApiError
     */
    public static getDataModelRangeNameOptionsByGroupZone({
        id,
        requestBody,
    }: {
        /**
         * Data Model Id
         */
        id: number,
        requestBody: {
            groupZones: Array<{
                groupId: number;
                zoneId: number;
            }>;
        },
    }): CancelablePromise<Record<string, Array<DataModelRangeName>>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dataModel/{id}/rangeName/options-by-group-zone',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get list of guideline items
     * @returns DataModelRangeGuidelineItem Success
     * @throws ApiError
     */
    public static getDataModelGuidelineItems({
        id,
    }: {
        id: number,
    }): CancelablePromise<Array<DataModelRangeGuidelineItem>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dataModel/{id}/rangeGuidelineItem',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Create guideline item
     * @returns any Success
     * @throws ApiError
     */
    public static createDataModelGuidelineItem({
        id,
        requestBody,
    }: {
        id: number,
        requestBody: {
            dataModelRangeNameId: number;
            spreadMin?: number | null;
            spreadTarget?: number | null;
            spreadMax?: number | null;
            progressionMin?: number | null;
            progressionTarget?: number | null;
            progressionMax?: number | null;
        },
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dataModel/{id}/rangeGuidelineItem',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update guideline item
     * @returns any Success
     * @throws ApiError
     */
    public static updateDataModelGuidelineItem({
        id,
        itemId,
        requestBody,
    }: {
        id: number,
        itemId: number,
        requestBody: {
            dataModelRangeNameId?: number | null;
            spreadMin?: number | null;
            spreadTarget?: number | null;
            spreadMax?: number | null;
            progressionMin?: number | null;
            progressionTarget?: number | null;
            progressionMax?: number | null;
        },
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/dataModel/{id}/rangeGuidelineItem/{itemId}',
            path: {
                'id': id,
                'itemId': itemId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete guideline item
     * @returns any Success
     * @throws ApiError
     */
    public static deleteDataModelGuidelineItem({
        id,
        itemId,
    }: {
        id: number,
        itemId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/dataModel/{id}/rangeGuidelineItem/{itemId}',
            path: {
                'id': id,
                'itemId': itemId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * return composites of data model
     * @returns DataModelComposite Success
     * @throws ApiError
     */
    public static getDataModelComposites({
        id,
        requestBody,
    }: {
        /**
         * Data Model Id
         */
        id: number,
        requestBody: {
            /**
             * Pagination Limit
             */
            limit?: number;
            /**
             * Pagination Offset
             */
            offset?: number;
            /**
             * Data Model Salary Range Ids
             */
            salaryRangeIds?: Array<number>;
            /**
             * Data Model Composite Ids
             */
            compositeIds?: Array<number>;
            /**
             * Paymarket
             */
            paymarket?: Array<number>;
            /**
             * jobSubFamily filter
             */
            jobSubFamily?: Array<number>;
            /**
             * jobLevel filter
             */
            jobLevel?: Array<number>;
            /**
             * isLockedInRange flag
             */
            isLockedInRange?: boolean;
            /**
             * isUsedInCalculation flag
             */
            isUsedInCalculation?: boolean;
            /**
             * search filter
             */
            search?: string | null;
            sort?: DataModelCompositeSort;
        },
    }): CancelablePromise<Array<DataModelComposite>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dataModel/{id}/composite',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * export composites of data model
     * @returns any Success
     * @throws ApiError
     */
    public static exportDataModelComposites({
        id,
        requestBody,
    }: {
        /**
         * Data Model Id
         */
        id: number,
        requestBody?: {
            paymarket?: Array<number> | null;
            jobSubFamily?: Array<number> | null;
            jobLevel?: Array<number> | null;
            isLockedInRange?: boolean | null;
            isUsedInCalculation?: boolean | null;
            /**
             * Table config
             */
            config?: Array<DataModelSalaryRangeExportTableConfig>;
        },
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dataModel/{id}/composite/export',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * return composite counts for a data model
     * @returns DataModelCompositeStats Success
     * @throws ApiError
     */
    public static getDataModelCompositeStats({
        id,
    }: {
        /**
         * Data Model Id
         */
        id: number,
    }): CancelablePromise<DataModelCompositeStats> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dataModel/{id}/composite/stats',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * return eligibility coverage stats for a data model
     * @returns DataModelEligibilityStats Success
     * @throws ApiError
     */
    public static getDataModelEligibilityStats({
        id,
    }: {
        /**
         * Data Model Id
         */
        id: number,
    }): CancelablePromise<DataModelEligibilityStats> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dataModel/{id}/eligibilityStats',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * update data model composite
     * @returns any Success
     * @throws ApiError
     */
    public static updateDataModelComposite({
        id,
        dataModelCompositeId,
        requestBody,
    }: {
        /**
         * Data Model Id
         */
        id: number,
        /**
         * Data Model Composite Id
         */
        dataModelCompositeId: number,
        requestBody?: {
            isLockedInRange?: boolean | null;
            isUsedInCalculation?: boolean | null;
        },
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/dataModel/{id}/composite/{dataModelCompositeId}',
            path: {
                'id': id,
                'dataModelCompositeId': dataModelCompositeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * update data model composite salary range
     * @returns DataModelComposite Success
     * @throws ApiError
     */
    public static updateDataModelCompositeSalaryRange({
        id,
        dataModelCompositeId,
        requestBody,
    }: {
        /**
         * Data Model Id
         */
        id: number,
        /**
         * Data Model Composite Id
         */
        dataModelCompositeId: number,
        requestBody?: {
            dataModelRangeNameId: number;
        },
    }): CancelablePromise<DataModelComposite> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/dataModel/{id}/composite/{dataModelCompositeId}/salaryRange',
            path: {
                'id': id,
                'dataModelCompositeId': dataModelCompositeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * exclude composites from data model
     * @returns any Success
     * @throws ApiError
     */
    public static massCompositesUpdate({
        id,
        requestBody,
    }: {
        /**
         * Data Model Id
         */
        id: number,
        requestBody: {
            action: DataModelSalaryRangeMassCompositeUpdateAction;
            /**
             * Data model composite ids
             */
            compositeIds?: Array<number>;
            filter?: {
                paymarket?: Array<number> | null;
                jobSubFamily?: Array<number> | null;
                jobLevel?: Array<number> | null;
            };
        },
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dataModel/{id}/composite/mass',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * move composites to recommended name
     * @returns any Success
     * @throws ApiError
     */
    public static moveCompositesToRecommendedName({
        id,
        requestBody,
    }: {
        /**
         * Data Model Id
         */
        id: number,
        requestBody: {
            /**
             * Data model composite ids
             */
            compositeIds?: Array<number>;
            filter?: {
                paymarket?: Array<number> | null;
                jobSubFamily?: Array<number> | null;
                jobLevel?: Array<number> | null;
            };
        },
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dataModel/{id}/compositesMoveToRecommended',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Edit mass data model salary range
     * @returns DataModelSalaryRange Success
     * @throws ApiError
     */
    public static editMassDataModelSalaryRange({
        id,
        requestBody,
    }: {
        /**
         * data model Id
         */
        id: number,
        requestBody: {
            salaryRangeIds?: Array<number>;
            rangeSetIds?: (Array<number> | boolean);
            valueToChange: DataModelMassActionValueToChange;
            propose: DataModelMassActionPropose;
            value?: number;
            filter?: {
                rangeZones?: (Array<number> | boolean);
                rangeGroups?: (Array<number> | boolean);
                rangeNames?: Array<number>;
                rangeSets?: Array<{
                    rangeZoneId: number;
                    rangeGroupId: number;
                }>;
                search?: string;
            };
        },
    }): CancelablePromise<Array<DataModelSalaryRange>> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/dataModel/{id}/salaryRange/mass',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Return distinct (zone, group) combinations that have at least one salary range in the data model
     * @returns DataModelSalaryRangeZoneGroupCombination Success
     * @throws ApiError
     */
    public static getDataModelSalaryRangeZoneGroupCombinations({
        id,
    }: {
        /**
         * Data Model Id
         */
        id: number,
    }): CancelablePromise<Array<DataModelSalaryRangeZoneGroupCombination>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dataModel/{id}/salaryRange/zone-group-combinations',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Generate midpoints, minimums and maximums for ranges in a data model
     * @returns any Success
     * @throws ApiError
     */
    public static setDataModelSalaryRangeValues({
        id,
        requestBody,
    }: {
        /**
         * Data Model Id
         */
        id: number,
        requestBody: SetRangeValuesRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dataModel/{id}/salaryRange/set-values',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Edit data model salary range
     * @returns DataModelSalaryRange Success
     * @throws ApiError
     */
    public static editDataModelSalaryRange({
        id,
        salaryRangeId,
        requestBody,
    }: {
        /**
         * data model Id
         */
        id: number,
        /**
         * salary range Id
         */
        salaryRangeId: number,
        requestBody: {
            min?: number;
            mid?: number;
            max?: number;
            spread?: number | null;
        },
    }): CancelablePromise<DataModelSalaryRange> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/dataModel/{id}/salaryRange/{salaryRangeId}',
            path: {
                'id': id,
                'salaryRangeId': salaryRangeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete data model salary range
     * @returns any Success
     * @throws ApiError
     */
    public static deleteDataModelSalaryRange({
        id,
        salaryRangeId,
    }: {
        /**
         * data model Id
         */
        id: number,
        /**
         * salary range Id
         */
        salaryRangeId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/dataModel/{id}/salaryRange/{salaryRangeId}',
            path: {
                'id': id,
                'salaryRangeId': salaryRangeId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update data model salary range commentText
     * @returns DataModelSalaryRange Success
     * @throws ApiError
     */
    public static updateDataModelSalaryRangeCommentText({
        id,
        salaryRangeId,
        requestBody,
    }: {
        /**
         * data model Id
         */
        id: number,
        /**
         * salary range Id
         */
        salaryRangeId: number,
        requestBody: {
            text: string;
        },
    }): CancelablePromise<DataModelSalaryRange> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/dataModel/{id}/salaryRange/{salaryRangeId}/comment',
            path: {
                'id': id,
                'salaryRangeId': salaryRangeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * return data model range sets
     * @returns DataModelRangeSet Success
     * @throws ApiError
     */
    public static getDataModelRangeSets({
        id,
        limit,
        offset,
        rangeZones,
        rangeGroups,
        rangeSetStatus,
        search,
        sort,
        ignorePagination,
    }: {
        /**
         * Data Model Id
         */
        id: number,
        /**
         * Pagination Limit
         */
        limit?: number,
        /**
         * Pagination Offset
         */
        offset?: number,
        rangeZones?: Array<number>,
        rangeGroups?: Array<number>,
        rangeSetStatus?: Array<DataModelRangeSetStatus>,
        search?: string,
        /**
         * Sorting
         */
        sort?: DataModelRangeSetSort,
        ignorePagination?: boolean,
    }): CancelablePromise<Array<DataModelRangeSet>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dataModel/{id}/rangeSet',
            path: {
                'id': id,
            },
            query: {
                'limit': limit,
                'offset': offset,
                'rangeZones': rangeZones,
                'rangeGroups': rangeGroups,
                'rangeSetStatus': rangeSetStatus,
                'search': search,
                'sort': sort,
                'ignorePagination': ignorePagination,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * return list of DataModelRangeSets aggregators with summary
     * @returns any Success
     * @throws ApiError
     */
    public static getDataModelRangeSetAggregations({
        id,
        limit,
        offset,
        groupBy,
        search,
        rangeZones,
        rangeGroups,
        sort,
    }: {
        /**
         * Data Model Id
         */
        id: number,
        /**
         * Pagination Limit
         */
        limit?: number,
        /**
         * Pagination Offset
         */
        offset?: number,
        groupBy?: DataModelRangeSetAggregation,
        search?: string,
        rangeZones?: Array<number>,
        rangeGroups?: Array<number>,
        /**
         * Sorting
         */
        sort?: DataModelRangeSetSort,
    }): CancelablePromise<Array<{
        id?: number;
        fullName?: string;
        currencyCode?: string | null;
        currencyRate?: number | null;
        totalBelowMin?: number;
        totalBelowMinSum?: number;
        rSquared?: number | null;
        totalDone?: number;
        totalRangeSets?: number;
        totalNumEmployees?: number;
        totalNumJobs?: number;
    }>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dataModel/{id}/rangeSet/aggregate',
            path: {
                'id': id,
            },
            query: {
                'limit': limit,
                'offset': offset,
                'groupBy': groupBy,
                'search': search,
                'rangeZones': rangeZones,
                'rangeGroups': rangeGroups,
                'sort': sort,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * return list of SalaryRanges for DataModel RangeSet
     * @returns DataModelSalaryRange Success
     * @throws ApiError
     */
    public static getDataModelRangeSetSalaryRanges({
        id,
        rangeSetId,
        limit,
        offset,
        ignorePagination,
        sort,
    }: {
        /**
         * data model Id
         */
        id: number,
        /**
         * range set Id
         */
        rangeSetId: number,
        limit?: number,
        offset?: number,
        ignorePagination?: boolean,
        /**
         * Sorting
         */
        sort?: DataModelSalaryRangeSort,
    }): CancelablePromise<Array<DataModelSalaryRange>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dataModel/{id}/rangeSet/{rangeSetId}',
            path: {
                'id': id,
                'rangeSetId': rangeSetId,
            },
            query: {
                'limit': limit,
                'offset': offset,
                'ignorePagination': ignorePagination,
                'sort': sort,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Edit data model range set
     * @returns DataModelRangeSet Success
     * @throws ApiError
     */
    public static editDataModelRangeSet({
        id,
        rangeSetId,
        requestBody,
    }: {
        /**
         * data model Id
         */
        id: number,
        /**
         * range set Id
         */
        rangeSetId: number,
        requestBody: {
            status?: DataModelRangeSetStatus;
            min?: number;
        },
    }): CancelablePromise<DataModelRangeSet> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/dataModel/{id}/rangeSet/{rangeSetId}',
            path: {
                'id': id,
                'rangeSetId': rangeSetId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Populate data model with salary range data
     * @returns DataModel Success
     * @throws ApiError
     */
    public static populateDataModel({
        id,
        requestBody,
    }: {
        /**
         * Data Model Id
         */
        id: number,
        requestBody: PopulateDataModelRequest,
    }): CancelablePromise<DataModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dataModel/{id}/populate',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Populate data model from scratch using wizard data
     * @returns DataModel Success
     * @throws ApiError
     */
    public static populateDataModelFromScratch({
        id,
        requestBody,
    }: {
        /**
         * Data Model Id
         */
        id: number,
        requestBody: PopulateFromScratchRequest,
    }): CancelablePromise<DataModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dataModel/{id}/populateFromScratch',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Add range data - create all related entities for given range names, zones and groups
     * @returns DataModel Success
     * @throws ApiError
     */
    public static addRangeData({
        id,
        requestBody,
    }: {
        /**
         * Data Model Id
         */
        id: number,
        requestBody: AddRangeDataRequest,
    }): CancelablePromise<DataModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dataModel/{id}/addRangeData',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get CompositeRangeAssignment list for Data Model
     * Returns a flat list of Composites with attached SalaryRanges for each typeOfPay filtered by Data Model
     * @returns DataModelComposite List of DataModelCompositeRangeAssignment
     * @throws ApiError
     */
    public static getDataModelCompositeRangeAssignments({
        id,
        paymarket,
        search,
        rangeAssignment,
        jobSubFamily,
        jobLevel,
        grade,
        limit,
        offset,
    }: {
        /**
         * Data Model Id
         */
        id: number,
        paymarket?: Array<number>,
        search?: string | null,
        rangeAssignment?: RangeAssignmentOption,
        jobSubFamily?: Array<number>,
        jobLevel?: Array<number>,
        /**
         * Filter by company job grade
         */
        grade?: Array<string>,
        /**
         * Pagination Limit
         */
        limit?: number,
        /**
         * Pagination Offset
         */
        offset?: number,
    }): CancelablePromise<Array<DataModelComposite>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dataModel/{id}/rangeAssignment',
            path: {
                'id': id,
            },
            query: {
                'paymarket': paymarket,
                'search': search,
                'rangeAssignment': rangeAssignment,
                'jobSubFamily': jobSubFamily,
                'jobLevel': jobLevel,
                'grade': grade,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Create data model composite range assignments
     * Creates data model composite range assignments based on filters and range parameters
     * @returns any Success
     * @throws ApiError
     */
    public static createDataModelCompositeRangeAssignments({
        id,
        requestBody,
    }: {
        /**
         * Data Model Id
         */
        id: number,
        requestBody: {
            compositeIds: Array<number>;
            rangeZoneId: number;
            rangeGroupId: number;
            rangeNameId: number;
        },
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dataModel/{id}/rangeAssignment',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Export data model range assignments
     * Schedules an async job to export data model range assignments data to CSV format
     * @returns any Export job scheduled successfully
     * @throws ApiError
     */
    public static exportDataModelRangeAssignments({
        id,
        requestBody,
    }: {
        /**
         * Data Model Id
         */
        id: number,
        requestBody: {
            /**
             * Filter by paymarket IDs
             */
            paymarket?: Array<number>;
            /**
             * Filter by job sub-family IDs
             */
            jobSubFamily?: Array<number>;
            /**
             * Filter by job level IDs
             */
            jobLevel?: Array<number>;
            /**
             * Filter by company job grade
             */
            grade?: Array<string>;
            /**
             * Search term for job titles
             */
            search?: string | null;
            rangeAssignment?: RangeAssignmentOption;
            /**
             * Filter by type of pay
             */
            typeOfPay?: SalaryRangeTypeOfPay;
            /**
             * Max number of items to return
             */
            limit?: number;
            /**
             * Number of items to skip
             */
            offset?: number;
        },
    }): CancelablePromise<{
        success: boolean;
        /**
         * ID of the created export file record
         */
        exportFileId: number;
        message: string;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dataModel/{id}/rangeAssignment/export',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
